import RemoveFromPoolModal from './RemoveFromPoolModal';

export default RemoveFromPoolModal;
